import {BaseApiModel} from "../../../infrastructure/models/base-api-model";

export class SponsorshipApiModel extends BaseApiModel {
  mobileName: String;
  desktopName: String;
  countryIds: Array<Number>;
  mobileUrl: String;
  desktopUrl: String;

  constructor(model) {
    super(model);
    this.mobileName = model.mobileName;
    this.desktopName = model.desktopName;
    this.countryIds = model.countryIds;
    this.mobileUrl = model.mobileUrl;
    this.desktopUrl = model.desktopUrl;
  }
}
